import { render, staticRenderFns } from "./DataExportSellingRepresentative.vue?vue&type=template&id=40f00d0c&scoped=true&"
import script from "./DataExportSellingRepresentative.vue?vue&type=script&lang=ts&"
export * from "./DataExportSellingRepresentative.vue?vue&type=script&lang=ts&"
import style0 from "./DataExportSellingRepresentative.vue?vue&type=style&index=0&id=40f00d0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f00d0c",
  null
  
)

export default component.exports